module.exports = __webpack_public_path__ + "static/media/nh-icon-notes-ai.a35df29f.png";